import type {IData} from "@/interfaces";

export const META: IData = {
    budgetTitles: {
        "2019-SoSe": "3.5.2.7 SS 2019",
        "2019-WiSe": "3.5.2.8 WS 2019/20",
        "2020-SoSe": "3.5.2.9 SS 2020",
        "2020-WiSe": "3.5.2.0 WS 2020/21",
        "2021-SoSe": "3.5.2.1 SS 2021",
        "2021-WiSe": "3.5.2.2 WS 2021/22",
        "2022-SoSe": "3.5.2.3 SS 2022",
        "2022-WiSe": "3.5.2.4 WS 2022/23",
        "2023-SoSe": "3.5.2.5 SS 2023",
        "2023-WiSe": "3.5.2.6 WS 2023/24",
        "2024-SoSe": "3.5.1.3 SS 2024",
        "2024-WiSe": "3.5.1.4 WS 2024/25",
        "2025-SoSe": "3.5.1.5 SS 2025",
        "2025-WiSe": "3.5.1.6 WS 2025/26"
    },
    budgetTitlesBfsg: {
        "2021-WiSe": "3.5.3.6 WS 2021/22",
        "2022-SoSe": "3.5.3.7 SS 2022",
        "2022-WiSe": "3.5.3.8 WS 22/23",
        "2023-SoSe": "3.5.3.9 SS 23",
        "2023-WiSe": "3.5.3.2 WS 2023/24",
        "2024-SoSe": "3.5.3.3 SS 2024",
        "2024-WiSe": "3.5.3.4 WS 2024/25",
        "2025-SoSe": "3.5.3.1 BFSG (beantragbar)",
        "2025-WiSe": "3.5.3.1 BFSG (beantragbar)"
    },
}